import { Box, CardContent } from "@mui/material";
import { FaArrowLeft, FaBook, FaCalendarAlt, FaClock } from "react-icons/fa";
import { Link } from "react-router-dom";

function HomeworkCard({ homework }) {
  return (
    <Box className="assessment-card homework-card">
      {" "}
      {/* Visual */}{" "}
      <div className="assessment-visual homework-visual">
        {" "}
        <div className="assessment-top">
          {" "}
          <span className="assessment-brand"> PureEng </span>{" "}
          <span className="assessment-type"> HOMEWORK </span>{" "}
        </div>{" "}
        <div className="assessment-icon">
          {" "}
          <FaBook />{" "}
        </div>{" "}
        <div className="assessment-visual-title">
          {" "}
          <strong>KEEP PRACTICING</strong> <span>English Homework</span>{" "}
        </div>{" "}
      </div>{" "}
      {/* Content */}{" "}
      <CardContent className="assessment-content">
        {" "}
        <span className="assessment-badge homework-badge">
          {" "}
          واجب منزلي{" "}
        </span>{" "}
        <h3 className="assessment-title"> {homework.title} </h3>{" "}
        <p className="assessment-description">
          {" "}
          {homework.description || "حل الواجب وثبّت معلوماتك بعد الدرس."}{" "}
        </p>{" "}
        {/* Details */}{" "}
        <div className="assessment-details">
          {" "}
          <div className="assessment-detail">
            {" "}
            <div className="detail-icon">
              {" "}
              <FaCalendarAlt />{" "}
            </div>{" "}
            <div>
              {" "}
              <span>يفتح في</span>{" "}
              <strong>
                {" "}
                {homework.opensAtUtc
                  ? new Date(homework.opensAtUtc).toLocaleDateString("ar-EG")
                  : "غير محدد"}{" "}
              </strong>{" "}
            </div>{" "}
          </div>{" "}
          <div className="assessment-detail">
            {" "}
            <div className="detail-icon">
              {" "}
              <FaClock />{" "}
            </div>{" "}
            <div>
              {" "}
              <span>ينتهي في</span>{" "}
              <strong>
                {" "}
                {homework.closesAtUtc
                  ? new Date(homework.closesAtUtc).toLocaleDateString("ar-EG")
                  : "غير محدد"}{" "}
              </strong>{" "}
            </div>{" "}
          </div>{" "}
        </div>{" "}
        <Link
          className="assessment-button homework-button"
          to={`/homeworks/${homework.id}/start`}
        >
          {" "}
          <span>ابدأ الواجب</span> <FaArrowLeft />{" "}
        </Link>{" "}
      </CardContent>{" "}
    </Box>
  );
};
export default HomeworkCard;